import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5156da06 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _8fab2296 = () => interopDefault(import('..\\pages\\reimbursement\\index.vue' /* webpackChunkName: "pages_reimbursement_index" */))
const _ad042404 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _7c6b4bfe = () => interopDefault(import('..\\pages\\selection.vue' /* webpackChunkName: "pages_selection" */))
const _fdc36dc2 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _6d2df048 = () => interopDefault(import('..\\pages\\enroll\\eligibility.vue' /* webpackChunkName: "pages_enroll_eligibility" */))
const _f15b679a = () => interopDefault(import('..\\pages\\enroll\\patient-information.vue' /* webpackChunkName: "pages_enroll_patient-information" */))
const _ea82fbf6 = () => interopDefault(import('..\\pages\\enroll\\prescriber-information.vue' /* webpackChunkName: "pages_enroll_prescriber-information" */))
const _55ed265c = () => interopDefault(import('..\\pages\\enroll\\success.vue' /* webpackChunkName: "pages_enroll_success" */))
const _7614d7de = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _7622ef5f = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _763f1e61 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _764d35e2 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _aa09d9c2 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _d8e31672 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _5156da06,
    name: "error"
  }, {
    path: "/reimbursement",
    component: _8fab2296,
    name: "reimbursement"
  }, {
    path: "/rejection",
    component: _ad042404,
    name: "rejection"
  }, {
    path: "/selection",
    component: _7c6b4bfe,
    name: "selection"
  }, {
    path: "/unlock",
    component: _fdc36dc2,
    name: "unlock"
  }, {
    path: "/enroll/eligibility",
    component: _6d2df048,
    name: "enroll-eligibility"
  }, {
    path: "/enroll/patient-information",
    component: _f15b679a,
    name: "enroll-patient-information"
  }, {
    path: "/enroll/prescriber-information",
    component: _ea82fbf6,
    name: "enroll-prescriber-information"
  }, {
    path: "/enroll/success",
    component: _55ed265c,
    name: "enroll-success"
  }, {
    path: "/errors/400",
    component: _7614d7de,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _7622ef5f,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _763f1e61,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _764d35e2,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _aa09d9c2,
    name: "errors-500"
  }, {
    path: "/",
    component: _d8e31672,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
